module.exports = __webpack_public_path__ + "static/media/York.df8f35d9.svg";